import { httpClient } from '../httpClient';
export class BundleOptionHikari01InheritedRepository {
    constructor() {
        this.basePath = 'bundle-option-hikari01-inherited';
    }
    async fetch(params) {
        const { data } = await httpClient.get(`${this.basePath}/${params.bundleOptionHikari01InheritedId}/fetch`);
        return data;
    }
    async fetchList() {
        const { data } = await httpClient.get(
        // JWT内accountIdを使用して検索
        `${this.basePath}/list/fetch`);
        return data;
    }
    async terminate(params) {
        const { data } = await httpClient.post(`${this.basePath}/${params.bundleOptionHikari01InheritedId}/terminate`);
        return data;
    }
    async changeMailPassword(params) {
        const { data } = await httpClient.post(`${this.basePath}/${params.bundleOptionHikari01InheritedId}/mail-password/change/`, JSON.stringify(params));
        return data;
    }
    async getSpaaqsMailPack(params) {
        const { data } = await httpClient.get(`${this.basePath}/spaaqs-mail-pack/${params.accountId}/fetch`);
        return data;
    }
}
